import { DEFAULT_ADDRESS } from "./brand";
import { SparklesIcon, MusicIcon, HeartIcon, UsersIcon } from "./icons";

/** Conteúdo inicial do site da igreja original, antes de /info responder. */
export const DEFAULT_INFO = {
  churchName: 'IEAD Hulene "B"',
  tagline: "Comunidade viva em Maputo",
  heroTitle: "Firmar, Expandir e Discipular",
  heroSubtitle: "Louvor, oração e Palavra para toda a família.",
  heroVerse: "Alegrei-me quando me disseram: Vamos à casa do Senhor.",
  heroVerseRef: "Salmo 122:1",
  ministries: [
    { id: "min-1", name: "Jovens", blurb: "Encontros semanais, discipulado e ação social." },
    { id: "min-2", name: "Senhoras", blurb: "Círculo de oração e apoio mútuo durante a semana." },
    { id: "min-3", name: "Crianças", blurb: "Cultinho infantil com histórias, louvor e atividades." },
    { id: "min-4", name: "Louvor", blurb: "Equipe dedicada a conduzir a igreja em adoração." },
    { id: "min-5", name: "Evangelismo", blurb: "Visitas, ações na comunidade e apoio a famílias." },
  ],
  leadership: [
    {
      id: "lead-1",
      name: "Pastor Marcelino Mário Mondlane",
      role: "Pastor Presidente",
      image: "/leadership/pastor-marcelino-mondlane.jpg",
      bio:
        "Pastor Presidente da IEAD — Ministério Maxaquene–Mahotas, que reúne mais de 40 igrejas. Ao longo do seu ministério, tem servido no ensino da Palavra, na pregação e no cuidado pastoral das comunidades.\n\nÉ bacharel e mestre em Teologia pela Universidade Sul-Americana. Exerceu também funções de liderança nacional nas Assembleias de Deus de Moçambique, incluindo Secretário Nacional e Vice-Presidente.\n\nParticipou ainda em entrevistas e programas cristãos, incluindo “Desmistificando Mistérios à Luz da Bíblia”, contribuindo para a reflexão bíblica e o fortalecimento da fé.\n\nÉ também professor de Teologia na Escola Bíblica, contribuindo para a formação bíblica e ministerial de novos obreiros e líderes cristãos.\n\nActualmente, participa no Diálogo Nacional Inclusivo, processo de auscultação e concertação promovido pelas instituições do Estado moçambicano, contribuindo para a reflexão sobre a paz, a reconciliação, a unidade nacional e o futuro do país.",
    },
    {
      id: "lead-2",
      name: "Abdubário Michaque",
      role: "Secretário",
      image: "/leadership/secretary-abdubario-michaque.jpg",
      bio:
        "Abdubário Michaque serve como Secretário da Igreja Evangélica Assembleia de Deus — Ministério Maxaquene–Mahotas, Zona de Hulene “B”, contribuindo activamente para a organização, comunicação e desenvolvimento das actividades da igreja.\n\nAlém do trabalho administrativo, exerce o ministério da pregação da Palavra de Deus, participando de cultos, evangelizações e outras iniciativas voltadas para o fortalecimento espiritual da igreja e para a expansão do Evangelho.\n\nProfissional da área de Engenharia Electrónica e de Telecomunicações, procura também colocar os seus conhecimentos e experiência ao serviço da obra de Deus, apoiando a modernização dos processos, a organização da informação e o desenvolvimento de soluções digitais que facilitem a comunicação e a gestão da igreja.\n\nAcredita que servir a Deus vai além de ocupar uma posição: é colocar os dons, conhecimentos e oportunidades recebidos ao serviço das pessoas e do Reino de Deus.",
    },
  ],
  scheduleHours: [
    "Domingo — 07:00 • Culto de Louvor",
    "Quarta — 18:30 • Culto de Oração",
    "Sexta — 18:30 • Estudo Bíblico",
  ],
  contacts: {
    phone: "+258 82 631 9370",
    whatsapp: "+258 82 631 9370",
    email: "abumichaque@gmail.com",
    address: DEFAULT_ADDRESS,
    directionsUrl: "",
    mapEmbed: "",
  },
  ctas: {
    shareTemplate: "",
    calendarUrl: "",
    donateUrl: "",
    streamUrl: "",
    appUrl: "",
    prayerUrl: "",
    whatsappLink: "",
    social: { facebook: "", instagram: "", youtube: "" },
  },
};

const MINISTRY_ICONS = [
  UsersIcon,
  HeartIcon,
  SparklesIcon,
  MusicIcon,
  HeartIcon,
  UsersIcon,
];

export function ministryIconFor(name, index) {
  const n = String(name || "").toLowerCase();
  if (/jovem/.test(n)) return UsersIcon;
  if (/senhor|mulher|dama/.test(n)) return HeartIcon;
  if (/crian|infantil|kids/.test(n)) return SparklesIcon;
  if (/louvor|ador|músic|musica/.test(n)) return MusicIcon;
  if (/evangel|missão|missao/.test(n)) return HeartIcon;
  return MINISTRY_ICONS[index % MINISTRY_ICONS.length] || HeartIcon;
}

/** Ponto de partida de uma igreja nova: vazio até /info responder. */
export const GENERIC_INFO = {
  churchName: "",
  tagline: "",
  heroTitle: "",
  heroSubtitle: "",
  heroVerse: "",
  heroVerseRef: "",
  ministries: [],
  leadership: [],
  scheduleHours: [],
  contacts: { phone: "", whatsapp: "", email: "", address: "", directionsUrl: "", mapEmbed: "" },
  ctas: { ...DEFAULT_INFO.ctas, social: { ...DEFAULT_INFO.ctas.social } },
};
